<template>
  <div class="views-bulletin-emergency">
    <div class="views-bulletin-emergency-wrapper">
      <div class="views-bulletin-emergency__header">
        <div class="views-bulletin-emergency__header-left">
          緊急公告
        </div>
        <div class="views-bulletin-emergency__header-right">
          *為必填
        </div>
      </div>

      <div class="views-bulletin-emergency__body">
        <el-form
          ref="form"
          class="views-bulletin-emergency__body-form"
          :model="form"
          :rules="rules"
          status-icon
          :show-message="false"
          label-position="top"
          size="medium"
          @submit.native.prevent
        >
          <div style="text-align: right;">
            <el-button
              size="small"
              type="danger"
              plain
              :class="{ 'views-bulletin-emergency__button--hidden': !isShowEmergencyNews }"
              :disabled="!isShowEmergencyNews || isSubmitting"
              @click="deleteEmergency"
            >
              解除緊急公告
            </el-button>
          </div>
          <div
            v-if="isShowEmergencyNews"
            class="views-bulletin-emergency__body-form-title"
          >
            編輯緊急公告
          </div>
          <div
            v-if="!isShowEmergencyNews"
            class="views-bulletin-emergency__body-form-title"
          >
            新增緊急公告
          </div>
          <el-form-item
            label="選擇預設公告"
            prop="mode"
            class="views-bulletin-emergency__body-form-item views-bulletin-emergency__body-form-item__radio-wrapper"
          >
            <div>
              <el-radio-group v-model="form.mode">
                <el-radio
                  v-for="(item, index) in defaultWithCustomMessages"
                  :key="index"
                  class="views-bulletin-emergency__body-form-item__radio"
                  :label="item.id"
                  @change="setFormValue(item)"
                >
                  {{ item.itemName }}
                </el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
          <div v-if="!isCustomizedMessage">
            <div class="views-bulletin-emergency__body-title">
              <div v-if="form.title">
                緊急公告標題：
              </div>
              <div>{{ form.title }}</div>
            </div>
            <div class="views-bulletin-emergency__body-content">
              <div v-if="form.description">
                緊急公告內容：
              </div>
              <div>{{ form.description }}</div>
            </div>
          </div>
          <div v-else>
            <div class="views-bulletin-emergency__body-title">
              <el-form-item
                label="緊急公告標題"
                prop="title"
                class="views-bulletin-emergency__body-form-item"
              >
                <el-input
                  v-model.lazy="form.title"
                  placeholder="請輸入緊急公告標題"
                  maxlength="20"
                  class="views-bulletin-emergency__body-title-input"
                  show-word-limit
                />
                <template>
                  <span>限 20 個字元</span>
                </template>
              </el-form-item>
            </div>
            <div class="views-bulletin-emergency__body-content">
              <el-form-item
                label="緊急公告內容"
                prop="description"
                class="views-bulletin-emergency__body-form-item"
              >
                <el-input
                  v-model.lazy="form.description"
                  class="views-bulletin-emergency__body-content-input"
                  type="textarea"
                  :autosize="{ minRows: 3 }"
                  placeholder="請輸入緊急公告內容"
                  maxlength="50"
                  @change="limitEmergencyContent"
                />
                <span
                  class="views-bulletin-emergency__body-content-count"
                >{{ form.description.length || 0 }}/50，</span>
                <template>
                  <span>限 50 個字元</span>
                </template>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>

      <div class="views-bulletin-emergency__footer">
        <el-button
          :disabled="isSubmitting"
          round
          @click="goPageBulletin"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          :disabled="isSubmitting"
          round
          @click="newEmergency"
        >
          送出
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
const CUSTOM_MESSAGE_CODE = '999'
export default {
  data () {
    return {
      isCustomizedMessage: false,
      isSubmitting: false,
      defaultWithCustomMessages: [],
      isShowEmergencyNews: false,
      form: {
        mode: '',
        title: '',
        description: ''
      },
      rules: {
        mode: [{ required: true, message: '', trigger: 'change' }]
      }
    }
  },
  mounted () {
    this.initPage()
  },
  beforeDestroy () {
  },

  methods: {
    async initPage () {
      try {
        this.fetchDefaultAndCustomEmergency()
        this.fetchEmergencyBeingPublished()
      } catch (error) {
        this.handlerError({ errorTitle: 'initPage Error', error })
      }
    },
    formatOrCustomMessage ({ Id = '', Title = '', ReferenceID = null, Description = '', IsDefault: isDefault = false } = {}) {
      return {
        itemName: isDefault ? Title : '自訂公告',
        id: isDefault && ReferenceID ? ReferenceID : Id,
        title: Title,
        description: Description,
        isDefault
      }
    },

    async fetchDefaultAndCustomEmergency () {
      try {
        const { data = [] } = await apiBulletin.getDefaultAndCustomEmergency()
        const formattedData = data.map(item => this.formatOrCustomMessage(item))
        const customMessage = formattedData.find(item => !item.isDefault) || this.formatOrCustomMessage({ Id: CUSTOM_MESSAGE_CODE, IsDefault: false })
        const defaultMessages = formattedData.filter(item => item.isDefault)

        if (formattedData.length > 0) {
          this.defaultWithCustomMessages = [...defaultMessages, customMessage]
        }
      } catch (error) {
        this.handlerError({ errorTitle: 'API Error:GET', error })
      }
    },

    async fetchEmergencyBeingPublished () {
      try {
        const { data } = await apiBulletin.getEmergencyBeingPublished()
        const formattedData = this.formatOrCustomMessage({
          ...data,
          IsDefault: !!(data?.ReferenceID)
        })

        if (formattedData.id && formattedData.title) {
          this.isShowEmergencyNews = true
          this.isCustomizedMessage = !formattedData.isDefault
          this.settingEmergency(formattedData)
        }
      } catch (error) {
        this.handlerError({ errorTitle: 'API Error:GET', error })
      }
    },

    settingEmergency (data) {
      this.form = {
        ...this.form,
        mode: data.id,
        title: data.title,
        description: data.description
      }
    },

    deleteEmergency () {
      this.isSubmitting = true
      this.$confirm('確認是否解除緊急公告？', '', { confirmButtonText: '確定', cancelButtonText: '取消' })
        .then(async () => {
          try {
            await apiBulletin.deleteEmergency()
            this.$message.success('解除緊急公告成功')
            this.goPageBulletin()
          } catch (error) {
            this.handlerError({ errorTitle: 'API Error:PUT', error })
          } finally {
            this.isSubmitting = false
          }
        })
        .catch(() => { this.isSubmitting = false })
    },

    setFormValue (item) {
      this.settingEmergency(item)
      this.isCustomizedMessage = !item.isDefault
    },

    goPageBulletin () {
      this.$router.push({ name: 'BulletinIndex' })
    },

    newEmergency () {
      this.isSubmitting = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm('確認是否新增緊急公告？', '', { confirmButtonText: '確定', cancelButtonText: '取消' })
            .then(async () => {
              try {
                const params = {
                  id: (CUSTOM_MESSAGE_CODE === this.form.mode) ? '' : this.form.mode,
                  title: this.form.title,
                  description: this.form.description
                }
                await apiBulletin.newEmergency(params)
                this.$message.success('新增緊急公告成功')
                this.goPageBulletin()
              } catch (error) {
                this.handlerError({ errorTitle: 'API Error:POST', error })
              } finally {
                this.isSubmitting = false
              }
            })
            .catch(() => { this.isSubmitting = false })
        } else {
          this.isSubmitting = false
          this.$message.error('請重新確認輸入內容')
          window.scrollTo({ top: 0, behavior: 'smooth' })
          return false
        }
      })
    },

    limitEmergencyContent () {
      this.form.description = this.form.description.slice(0, 50)
    },

    handlerError ({ errorTitle = 'error', message = '伺服器發生錯誤', error } = {}) {
      this.$message.error(message)
      console.error(errorTitle, error)
    }
  }
}
</script>

<style lang="sass">

.views-bulletin-emergency
  width: 100%
  height: 100%

.views-bulletin-emergency-wrapper
  width: 1140px
  margin: 50px auto 10px auto
  padding: 30px
  color: $mainFontColor
  background-color: $white
  box-sizing: border-box
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
  border-radius: $pageBorderRadius

.views-bulletin-emergency__header
  display: flex
  justify-content: space-between
  align-items: center

.views-bulletin-emergency__header-left
  color: $mainFontColor
  font-weight: bold
  font-size: map-get($fontSize,xx-large)

.views-bulletin-emergency__header-right
  color: #f00 // src/views/News/NewsEdit .tips

.views-bulletin-emergency__button--hidden
  display: none

.views-bulletin-emergency__body
  display: flex
  justify-content: center
  margin: 30px 0
  width: 100%
  min-height: 380px
  box-sizing: border-box

.views-bulletin-emergency__body-form
  width: 100%
  max-width: 600px
  margin: 0 auto

.views-bulletin-emergency__body-form-title
  font-size: 20px
  font-weight: bold
  margin: 20px 0

.views-bulletin-emergency__body-form-item
  width: 600px

.views-bulletin-emergency__body-form-item__radio-wrapper .el-form-item__content
  display: flex

.views-bulletin-emergency__body-form-item__radio
  margin-bottom: 5px

.views-bulletin-emergency__body-title
  min-height: 50px
  margin-bottom: 20px
  line-height: 1.6

.views-bulletin-emergency__body-content
  min-height: 120px
  line-height: 1.6
  white-space: pre-line

// .views-bulletin-emergency__body-title-input .el-input__inner
//   padding-right: 85px

// .views-bulletin-emergency__body-content-input .el-textarea__inner
//   padding-bottom: 30px

// .views-bulletin-emergency__body-content-count
//   position: absolute
//   right: 10px
//   bottom: 40px
//   font-size: 12px
//   color: #909399

.views-bulletin-emergency__footer
  display: flex
  justify-content: center
  padding-top: 30px
  border-top: solid 1px $borderDark1
</style>
